import createIcon from '../../createIcon';

/**
 * @component @name RawOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNzE1MSAxMy42MDk2TDE4LjMwNTEgMTEuMjQ5NkwxOS4wNjUxIDE0LjI4OTZIMjAuNTQ1MUwyMi4wNDUxIDguMjg5NjFIMjAuNTQ1MUwxOS44MDUxIDExLjI4OTZMMTkuMDY1MSA4LjI4OTYxSDE3LjU0NTFMMTYuODA1MSAxMS4yODk2TDE2LjA2NTEgOC4yODk2MUgxNC41NjUxTDE1LjI4NTEgMTEuMTg5NkwxNy43MTUxIDEzLjYwOTZaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMS45NTUwOCAzLjUwOTYxTDYuNzM1MDggOC4yODk2MUgzLjU2NTA4VjE0LjI4OTZINS4wNjUwOFYxMi4yODk2SDYuMTY1MDhMNy4wNjUwOCAxNC4yODk2SDguNTY1MDhMNy42NjUwOCAxMi4xODk2QzguMTY1MDggMTEuODg5NiA4LjU2NTA4IDExLjM4OTYgOC41NjUwOCAxMC43ODk2VjEwLjExOTZMOS45OTUwOCAxMS41NDk2TDkuMzE1MDggMTQuMjg5NkgxMC44MTUxTDExLjE5NTEgMTIuNzg5NkgxMS4yMzUxTDIwLjM0NTEgMjEuODk5NkwyMS43NTUxIDIwLjQ4OTZMMy4zNzUwOCAyLjA5OTYxTDEuOTU1MDggMy41MDk2MVpNNy4wNjUwOCAxMC43ODk2SDUuMDY1MDhWOS43ODk2MUg3LjA2NTA4VjEwLjc4OTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RawOff = createIcon('RawOff', [
  [
    'path',
    {
      d: 'M17.7151 13.6096L18.3051 11.2496L19.0651 14.2896H20.5451L22.0451 8.28961H20.5451L19.8051 11.2896L19.0651 8.28961H17.5451L16.8051 11.2896L16.0651 8.28961H14.5651L15.2851 11.1896L17.7151 13.6096Z',
      key: 'lcxe1f',
    },
  ],
  [
    'path',
    {
      d: 'M1.95508 3.50961L6.73508 8.28961H3.56508V14.2896H5.06508V12.2896H6.16508L7.06508 14.2896H8.56508L7.66508 12.1896C8.16508 11.8896 8.56508 11.3896 8.56508 10.7896V10.1196L9.99508 11.5496L9.31508 14.2896H10.8151L11.1951 12.7896H11.2351L20.3451 21.8996L21.7551 20.4896L3.37508 2.09961L1.95508 3.50961ZM7.06508 10.7896H5.06508V9.78961H7.06508V10.7896Z',
      key: 'rdakvx',
    },
  ],
]);

export default RawOff;
